<template>
  <div
    v-if="modal"
    class="overlay"
  >
    <Loader :isVisible="isLoading" />
    <div class="wrapper-modal">
      <div class="form-container">
        <div class="main wrapper main-form-container">
          <div class="column column-1">
            <div class="title modal">
              Fields Localization
            </div>
            <div class="back-btn">
              <Button
                :className="'back-local'"
                :title="'Back to Row Item'"
                :srcSvg="iconBackTo"
                :eventFunction="back"
                :hasBorder="true"
              />
            </div>
            <Tabs
              :removeMargin="true"
              :onSelectTab="handleSelectTab"
            >
              <Tab
                v-for="lang in languages"
                :id="lang.name"
                :key="lang.id"
                :name="lang.name"
                :selected="formData.mode === lang.name"
                :isLocalisation="true"
                :className="[isEditedForm.length
                  && isEditedForm.find(item => item.id === lang.id && !!item.value)
                  ? 'error-tab'
                  : 'tab']"
              >
                <ManuallyItemForm
                  v-if="manuallyItem"
                  :lang="lang"
                  :languages="languages"
                  :manuallyItem="manuallyItem"
                  :selected="formData.mode === lang.name"
                  @changedLanguage="changedLanguage"
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Tabs from '../common/Tabs/Tabs.vue';
import Tab from '../common/Tabs/Tab.vue';
import Button from '../common/Button.vue';
import iconBackTo from '../../assets/icons/icon-back-to.svg';
import ManuallyItemForm from '../forms/localization/ManuallyItemForm.vue';
import Loader from '../common/Loader.vue';
import { SET_FORM_CHANGES } from '../../store/actions/localization/localizationActions';

export default {
  name: 'CmsManuallyLocalization',
  components: {
    Loader,
    ManuallyItemForm,
    Tab,
    Tabs,
    Button,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    isRowTranslate: {
      type: Boolean,
      default: false,
    },
    isGridTranslate: {
      type: Boolean,
      default: false,
    },
    isPageTranslate: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    languages: {
      type: Array,
      default: () => [],
    },
    cmsPage: {
      type: Object,
      default: () => {},
    },
    manuallyItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      iconBackTo,
      formData: {
        mode: '',
        changedLanguage: {},
      },
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.localization.isLoading,
      isEditedForm: (state) => state.localization.isEditedForm,
    }),
    ...mapGetters([
      'getLanguages',
    ]),
  },
  created() {
    this.formData.mode = this.languages.length && this.languages[0].name;
  },
  methods: {
    toFolderMeta() {
      this.onClose();
    },
    handleSelectTab(id) {
      this.formData.mode = id;
      this.$store.dispatch(SET_FORM_CHANGES, this.formData.changedLanguage);
    },
    back() {
      this.onClose();
    },
    changedLanguage(value) {
      this.formData.changedLanguage = value;
    },
  },
};
</script>

<style scoped>
.form-container {
  overflow-y: auto;
  width: 100%;
}

.wrapper {
  display: flex;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10;
}

.wrapper-modal {
  background-color: #222222;
  border-radius: 4px;
  display: block;
  left: 50%;
  max-width: 100%;
  outline: none;
  overflow-wrap: break-word;
  position: absolute;
  text-decoration: none;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 700px;
  height: 750px;
  overflow: auto;
}

@media all and (max-height: 910px) {
  .wrapper-modal {
    top: 52%;
    height: 650px;
  }
}

.back-btn {
  padding-bottom: 20px;
}

.modal {
  color: inherit;
}

.back-local {
  padding-left: 0;
}
</style>
